module.exports = __webpack_public_path__ + "img/mt15.22aafda8.jpg";